import { z } from "zod";

export const newTagSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, "El nombre de la etiqueta es requerido")
    .max(50, "Máximo 50 caracteres")
    .regex(
      /^[\p{L}\p{N} ]+$/u,
      "Solo se permiten letras, números y espacios (sin caracteres especiales)",
    )
    .transform((val) => val.replace(/\s+/g, " ")), // Elimina espacios extra
  description: z
    .string()
    .trim()
    .min(1, "La descripción de la etiqueta es requerida")
    .max(500, "Máximo 500 caracteres"),
  active: z.boolean({
    error: (issue) =>
      issue.input === undefined ? "El estado es requerido" : undefined,
  }),
  image: z.instanceof(File).optional(),
});

export const editTagSchema = newTagSchema.extend({
  id: z.string(),
});

// Esquema para el formulario de edición (sin id requerido)
export const editTagFormSchema = newTagSchema;

export type NewTagFormData = z.infer<typeof newTagSchema>;
export type EditTagFormData = z.infer<typeof editTagSchema>;
export type EditTagFormSchemaData = z.infer<typeof editTagFormSchema>;
